<script setup lang="ts">
import { useMessage } from "naive-ui";
import { onMounted } from "vue";

// Configure global message instance
onMounted(() => {
    window.$message = useMessage();
});
</script>

<template>
    <!-- Empty component, just for setup -->
</template>
